// Import Swiper styles
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import { useEffect, useState } from 'react'
import { A11y, Keyboard, Mousewheel } from 'swiper/modules'
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react'

import ArrowLeft from '../../../../public/svg/arrow-left.svg'
import ArrowRight from '../../../../public/svg/arrow-right.svg'
import StarIcon from '../../../../public/svg/star.svg'
import styles from './Reviewslider.module.css'

export type ReviewsliderProps = {
  title?: string
  subtitle?: string
  reviews?: { rating?: number; content?: React.ReactNode; author?: string }[]
  layout?: 'default' | 'row'
}

export const SwiperNavButtons = () => {
  const swiper = useSwiper()

  const [disablePrev, setDisablePrev] = useState(false)
  const [disableNext, setDisableNext] = useState(false)

  useEffect(() => {
    if (swiper.isBeginning) {
      setDisablePrev(true)
    } else {
      setDisablePrev(false)
    }

    if (swiper.isEnd) {
      setDisableNext(true)
    } else {
      setDisableNext(false)
    }

    swiper.on('slideChange', () => {
      if (swiper.isBeginning) {
        setDisablePrev(true)
      } else {
        setDisablePrev(false)
      }
      if (swiper.isEnd) {
        setDisableNext(true)
      } else {
        setDisableNext(false)
      }
    })
  }, [swiper])

  return (
    <div className={styles['swiper-nav-btns']}>
      <button
        className={`${disablePrev ? styles.disabled : ''}`}
        onClick={() => swiper.slidePrev()}
        disabled={disablePrev}
      >
        <ArrowLeft />
        <span className="sr-only">Prev</span>
      </button>
      <button
        className={`${disableNext ? styles.disabled : ''}`}
        disabled={disableNext}
        onClick={() => swiper.slideNext()}
      >
        <ArrowRight />
        <span className="sr-only">Next</span>
      </button>
    </div>
  )
}

export const PhnxReviewslider: React.FC<ReviewsliderProps> = ({
  title,
  subtitle,
  reviews,
  layout,
}) => {
  return (
    <div className={styles['reviewslider']}>
      <div className="container">
        <div className={`${styles['inner-container']} ${styles[`layout-${layout}`]}`}>
          <div className={styles.content}>
            {title && <h2>{title}</h2>}
            {subtitle && <p>{subtitle}</p>}
          </div>
          <div className={styles.slider}>
            {reviews && reviews.length > 0 && (
              <Swiper
                slidesPerView={1}
                spaceBetween={30}
                keyboard={{ enabled: true }}
                mousewheel={true}
                modules={[A11y, Keyboard, Mousewheel]}
                className="mySwiper"
              >
                {reviews.map((review, index) => (
                  <SwiperSlide key={index}>
                    <div className={styles.slide}>
                      <div className={styles.rating}>
                        <ul>
                          {[...Array(review.rating)].map((_, i) => (
                            <li key={i}>
                              <StarIcon />
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className={styles.content}>{review.content}</div>
                      <div className={styles.author}>
                        <p>{review.author}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
                <SwiperNavButtons />
              </Swiper>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
